{
  "brandTitle": "VBB PLAY — Live Support",
  "brandShort": "VBB PLAY Support",
  "liveLabel": "VBB PLAY Live Support",
  "online": "Online",
  "offline": "Offline",
  "close": "Close",
  "moreOptions": "More options",
  "closeChat": "Close chat",
  "closeMenu": "Close menu",
  "operator": "VBB PLAY Operator",
  "removeFile": "Remove file",
  "attachFile": "Attach file",
  "loadFailed": "Could not load.",
  "fileTooLarge": "File is larger than 50 MB.",
  "sendFailed": "Message not sent ({{status}})",
  "networkError": "Network error. Please try again.",
  "nameRequired": "Enter your name.",
  "emailInvalid": "Enter a valid email address.",
  "topicRequired": "Select a topic.",
  "messageRequired": "Describe your issue briefly.",
  "consentRequired": "Privacy consent is required.",
  "requestFailed": "Request failed.",
  "messagePlaceholder": "Write a short description…",
  "sending": "Sending…",
  "startLive": "Start Live Support",
  "ratingFailed": "Could not submit rating.",
  "ratingPlaceholder": "Short comment (optional)",
  "contactSaveFailed": "Could not save contact details.",
  "save": "Save",
  "loginRequired": "Sign in to use Live Support.",
  "intakeHint": "Enter your details so we can help you faster.",
  "back": "Back",
  "yourName": "Your name",
  "yourEmail": "Your email (Gmail or other)",
  "emailPlaceholder": "email@example.com",
  "topicLabel": "Topic",
  "topicSelect": "Select…",
  "messageLabel": "Your issue or message",
  "consentLong": "I consent to processing of personal data and have read the Privacy Policy.",
  "soundOff": "🔊 Mute sound",
  "soundOn": "🔇 Unmute sound",
  "rateOperator": "⭐ Rate the operator",
  "editContact": "✎ Edit my personal details",
  "searchingOperator": "🔎 Looking for an operator...",
  "waitingOperator": "⏳ Request received. Waiting for an operator.",
  "operatorJoined": "Operator {{name}} joined the chat",
  "sendFailedShort": "Not sent",
  "retry": "Retry",
  "cameraShot": "📷 Take a photo",
  "pickPhoto": "🖼️ Choose photo",
  "pickVideo": "🎬 Choose video",
  "pickFile": "📁 Choose file or document",
  "textPlaceholder": "Message...",
  "messageAria": "Message",
  "sendAria": "Send",
  "emojiAria": "Emoji",
  "rateTitle": "Rate the operator",
  "submitRate": "Submit",
  "editContactTitle": "Edit my personal details",
  "cameraPermissionTitle": "Camera permission",
  "cameraPermissionBody": "Camera access is required to take a photo. The browser prompt may stay in the device language.",
  "allowCamera": "Allow",
  "notNow": "Not now",
  "namePlaceholder": "Name",
  "topic_deposit": "Deposit issue",
  "topic_withdraw": "Withdrawal issue",
  "topic_balance": "Balance issue",
  "topic_game": "Game issue",
  "topic_bonus": "Bonus issue",
  "topic_account": "Account / login issue",
  "topic_tech": "Technical issue",
  "topic_other": "Other question",
  "fileOpenFailed": "Could not open file: {{name}}",
  "retryShort": "Retry",
  "fileLoading": "Loading file: {{name}}",
  "emoji_smileys": "Smileys",
  "emoji_people": "Gestures",
  "emoji_nature": "Nature",
  "emoji_food": "Food",
  "emoji_activity": "Sports",
  "emoji_travel": "Travel",
  "emoji_objects": "Objects",
  "emoji_symbols": "Symbols",
  "emoji_flags": "Flags"
}
